module.exports = "/_next/static/images/TSVS-49852afb53fcda2d8bb567ee4a450c1e.svg";